module.exports = __webpack_public_path__ + "static/media/img-about-usp2.e658c7d3.jpg";